import CryptoJS from "crypto-js";

export function hexTohsl(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  
    var r = parseInt(result[1], 16);
    var g = parseInt(result[2], 16);
    var b = parseInt(result[3], 16);
  
    r = r / 255;
    g = g / 255;
    b = b / 255;
  
    var max = Math.max(r, g, b),
      min = Math.min(r, g, b);
    var h = (max + min) / 2;
  
    if (max === min) {
      h = 0; // achromatic
    } else {
      var d = max - min;
      // s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r:
          h = (g - b) / d + (g < b ? 6 : 0);
          break;
        case g:
          h = (b - r) / d + 2;
          break;
        case b:
          h = (r - g) / d + 4;
          break;
        default:
          break;
      }
      h /= 6;
    }
  
    // l = l * 100;
    // l = Math.round(l);
    h = Math.round(360 * h);
  
    // let colorInHSL = 'hsl(' + h + ', ' + s + '%, ' + l + '%)';
    return h;
  }

  export function bColor(length, hlsaVal) {
    let x = 0;
    let y = 100;
    let value = 95 / length;
    let color = [];
    for (let i = 0; i < length; i++) {
      x = x + value;
      y = y - value;
      color.push(
        "hsl(" + hlsaVal + ", " + parseInt(x) + "%, " + parseInt(y) + "%)"
      );
      // color.push({ x: parseInt(x), y: parseInt(y) })
    }
    return color;
  }

  export function hexToHSLA(hex, alpha = 1) {
    // Remove the hash if present
    hex = hex?.replace(/^#/, '');
    
    // Parse the hex values
    let r, g, b;
    if (hex?.length === 3) {
        // Convert 3-digit hex to 6-digit
        r = parseInt(hex[0] + hex[0], 16);
        g = parseInt(hex[1] + hex[1], 16);
        b = parseInt(hex[2] + hex[2], 16);
    } else {
        r = parseInt(hex?.slice(0, 2), 16);
        g = parseInt(hex?.slice(2, 4), 16);
        b = parseInt(hex?.slice(4, 6), 16);
    }
    
    // Convert RGB to HSL
    r /= 255;
    g /= 255;
    b /= 255;
    
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    let h, s, l = (max + min) / 2;
    
    if (max === min) {
        h = s = 0; // achromatic (gray)
    } else {
        const d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        
        switch (max) {
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
        }
        h /= 6;
    }
    
    // Convert to degrees and percentages
    h = Math.round(h * 360);
    s = Math.round(s * 100);
    l = Math.round(l * 100);
    
    // Ensure alpha is between 0 and 1
    alpha = Math.max(0, Math.min(1, alpha));
    
    return `hsla(${h}, ${s}%, ${l}%, ${alpha})`;
}

export function convertCryptKey(strKey) {
  console.log('ed strKey', strKey);

  const newKey = new Uint8Array(16).fill(0); // 16 bytes for AES-128
  
  // Convert string to Uint8Array using TextEncoder instead of Buffer
  const encoder = new TextEncoder();
  const strKeyBuffer = encoder.encode(strKey);

  console.log('ed strKeyBuffer', strKeyBuffer);

  for (let i = 0; i < strKeyBuffer.length; i++) {
      newKey[i % 16] ^= strKeyBuffer[i]; // XOR logic
  }

  return CryptoJS.lib.WordArray.create(newKey); // Convert to CryptoJS WordArray
}

export function decryptWithCryptoJS(encryptedHex, key) {
  try {
    // Convert the key to the correct format
    const convertedKey = convertCryptKey(key);

    // Decrypt the data
    const decrypted = CryptoJS.AES.decrypt(
      { ciphertext: CryptoJS.enc.Hex.parse(encryptedHex) }, // Parse hex-encoded ciphertext
      convertedKey, // Converted key
      {
        mode: CryptoJS.mode.ECB, // Use ECB mode
        padding: CryptoJS.pad.Pkcs7, // PKCS7 padding (default)
      },
    );

    // Convert decrypted WordArray to UTF-8 string
    return decrypted.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error("Decryption Error:", error.message);
    return null;
  }
}